
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35.549","height":"32.574"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 718","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Rectangle 275","d":"M5.152 20.4h2.017v2.47H5.152z"}}),_c('path',{attrs:{"data-name":"Rectangle 276","d":"M1.716 12.531h1.455v2.291H1.716z"}}),_c('path',{attrs:{"data-name":"Rectangle 277","d":"M3.824 12.531h1.455v2.291H3.824z"}}),_c('path',{attrs:{"data-name":"Rectangle 278","d":"M7.043 12.531h1.455v2.291H7.043z"}}),_c('path',{attrs:{"data-name":"Rectangle 279","d":"M9.151 12.531h1.455v2.291H9.151z"}}),_c('path',{attrs:{"data-name":"Path 6979","d":"M33.193 23.891h-.726v-1.647h-2.356v1.647h-.726v-1.647h-2.356v1.647h-.726v-1.647h-2.356v1.647h-.726v-1.647h-2.36v1.647h-.726v-1.647h-2.357v1.647h-.727v-1.647h-2.356v1.647h-.726v-1.647h-1.648v-13.9l-3.078-5.8V-.002h-.709v2.279H3.799V-.002H3.09v2.521l-3.091 5.82v24.232h2.094v-.354a4.067 4.067 0 118.134 0v.354h3.479v-.354a4.067 4.067 0 118.134 0v.354h3.48v-.354a4.067 4.067 0 118.134 0v.354h2.097v-10.33h-2.356zM11.379 8.075H.944l2.7-5.087h5.031zM.71 8.784h10.9v7.134H.71zm0 7.843h10.9v7.264H.71zm10.9 15.238h-.689a4.776 4.776 0 00-9.526 0H.706V24.6h10.9zm11.613 0h-.689a4.776 4.776 0 00-9.526 0h-.689v-8.912h.939v1.648h2.144v-1.648h.939v1.648h2.144v-1.648h.939v1.648h2.144v-1.648h.939v1.648h.718zm10.675-8.912h.939v8.912h-.686a4.776 4.776 0 00-9.525 0h-.69V24.6h.718v-1.648h.939V24.6h2.144v-1.648h.939V24.6h2.144v-1.648h.939V24.6h2.144z"}})])])
          )
        }
      }
    